import { RouterProvider } from 'react-router-dom';
import MainRouter from 'router/MainRouter';
import './App.css';

function App() {
  return (
    <RouterProvider router={MainRouter} />
  );
}

export default App;
